<template>
  <div class="field" :class="{ 'field--error': !!error }">
    <label v-if="label" :for="name ?? id">{{ label }}</label>
    <slot />
    <span v-if="error && typeof error === 'string'" class="field-helper">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    label?: string
    name?: string
    id?: string
    error?: string | boolean
  }>()
</script>

<style lang="scss" scoped>
  .field {
    --input-gap: 10px;
    --input-padding-y: 8px;
    --input-padding-x: 16px;
    --input-min-height: 56px;

    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      color: #555;
      font-size: 16px;
      font-weight: 500;
    }
    span {
      color: var(--status-color, #8e8e8e);
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.02em;
    }

    &--error {
      --status-color: #dd2c2f;
    }

    @include media("md") {
      --input-gap: 8px;
      --input-padding-y: 6px;
      --input-padding-x: 14px;
      --input-min-height: 48px;

      label {
        color: #555;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
</style>
